module.exports = __webpack_public_path__ + "img/10.88c711c1.png";